<template lang="pug">
  b-container(fluid)
    b-row
      b-col.page-wrap(cols="12")
        div(slot="header").d-flex.justify-content-between.page-header
          b-container.d-flex.justify-content-between(fluid, v-if="!AppState.isStandalone", style="padding-left: 0")
            div
              span.page-title {{$t('access-registration-history')}}
        b-card.table-card
          b-table(
            ref="approvalTable",
            :fields="fields",
            :items="approvalStatus",
            :current-page="page.current",
            :per-page="page.per",
            :empty-text="$t('no-content')",
            tbody-class="lmm-table-body",
            sort-by="phone",
            :sort-desc="false",
            show-empty)
            template(v-slot:cell(device_alias)="row")
              |{{row.item.device_alias}}
            template(v-slot:cell(device_pub_ip)="row")
              |{{row.item.device_pub_ip}}
            template(v-slot:cell(proposal_time)="row")
              |{{row.item.proposal_time| moment('YY-MM-DD HH:mm')}}
            template(v-slot:cell(start_time)="row")
              |{{row.item.start_time | moment('YY-MM-DD HH:mm')}}
            template(v-slot:cell(end_time)="row")
              |{{row.item.end_time | moment('YY-MM-DD HH:mm')}}
            template(v-slot:cell(requester_id)="row")
              |{{row.item.requester_id}} ({{row.item.requester_name}})
            template(v-slot:cell(approver_name)="row")
              |{{row.item.approver_name}}
            template(v-slot:cell(approve_state)="row")
              b-btn.approval-btn(variant="link" size="sm" @click="approvalStatusSubmit(row.item.pk)")
                span {{$t('registration-approve')}}
          div.d-flex.justify-content-between(slot="footer")
            div
              b-form-select(
                size="sm",
                v-model="page.per",
                :options="page.perOptions")
            b-pagination(
              size="sm",
              :total-rows="page.total",
              :per-page="page.per",
              v-model="page.current",
              class="my-0 float-right"
            )
</template>

<script>
import { ApprovalsAPI } from "../../../api"
import _ from "lodash"
import moment from "moment"
import { getCurrentLanguage } from "@/i18n"
import * as datePickerLocale from "vuejs-datepicker/dist/locale"
import Datepicker from "vuejs-datepicker"

export default {
  name: "access-registration-component",
  components: { Datepicker },
  methods: {
    async approvalStatus(ctx) {
      this.pageMounted = false
      let params = {
        type: "request",
        by: "proposal_time",
        start_date: moment(this.range.start).format("YYYY-MM-DD HH:mm:ss"),
        end_date: moment(this.range.end).format("YYYY-MM-DD HH:mm:ss"),
        limit: ctx.perPage,
        offset: ctx.perPage * (ctx.currentPage - 1),
        order: "desc",
        export_id: "approvalsTable",
      }
      const resp = await ApprovalsAPI.get("", { params })
      this.page.total = resp.data.meta.total_count
      this.approveInfo = resp.data.objects
      return resp.data.objects
    },
    approvalStatusSubmit(item) {
      let params = {
        context: { path: "reset_n", args: { v: "OTP" } },
        submit: {
          size: "md",
          color: "primary",
          text: "approval",
          sort: "admin",
        },
        reject: {
          size: "md",
          color: "danger",
          text: "reject-submit",
        },
        approveInfo: this.approveInfo,
        approvePK: item,
      }
      this.AppState.$emit("show-approval-request-dialog", params, (key, data) => {
        if (key === "submit") {
          let params = data
          ApprovalsAPI.post("", params).then(resp => {
            this.$refs.approvalTable.refresh()
            this.$awn.success(this.$t("approval-success"))
          })
        } else if (key === "reject") {
          let params = data
          ApprovalsAPI.post("", params).then(resp => {
            this.$refs.approvalTable.refresh()
            this.$awn.success(this.$t("approval-success"))
          })
        }
      })
    },
  },
  data() {
    let disabledDateInit = new Date()
    disabledDateInit.setDate(-1)
    return {
      options: [
        { value: "a", text: this.$t('management_page.requester') },
        { value: "b", text: this.$t('management_page.approver') },
      ],
      range: {
        start: new Date().setDate(-1),
        end: new Date(),
        disabledDates: { to: disabledDateInit },
        lang: datePickerLocale[getCurrentLanguage()],
      },
      pageMounted: false,
      fields: [
        // { key: 'pk', label: this.$t('access-num'), sortable: false },
        { key: "device_alias", label: this.$t("device-name"), sortable: false },
        { key: "device_pub_ip", label: this.$t("device-ip"), sortable: false },
        { key: "proposal_time", label: this.$t("application-date"), sortable: false },
        { key: "start_time", label: this.$t("start_time"), sortable: false },
        { key: "end_time", label: this.$t("end_time"), sortable: false },
        { key: "requester_id", label: this.$t("applicant"), sortable: false },
        { key: "approver_name", label: this.$t("approver"), sortable: false },
        { key: "approve_state", label: this.$t("approval-status"), sortable: false },
      ],
      approveInfo: [],
      page: {
        total: 0,
        current: 1,
        per: 10,
        perOptions: [
          { value: 5, text: "5" },
          { value: 10, text: "10" },
          { value: 15, text: "15" },
          { value: 20, text: "20" },
        ],
      },
      filter: {
        key: "alias",
        value: "",
        options: [
          { text: this.$t("device"), value: "alias" },
          { text: this.$t("ID"), value: "e-mail" },
        ],
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
  margin: 0;
}

.row,
.col,
.container-fluid {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.page-header {
  padding: 0 1.5rem 0 1.5rem;
  margin-bottom: 0.5rem;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
}

.btn-link {
  color: black !important;
  font-weight: 400;
  border: 1px solid#6F6F6F;
}

.btn-link:hover {
  color: black !important;
  background-color: #f7f7f7 !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
  text-decoration: none;
}

.btn-link:active {
  color: black !important;
  background-color: #cbcbcb !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

::v-deep .b-table {
  margin: 0;
  table-layout: fixed;
  width: 100%;
  tr,
  td,
  th {
    padding: 0.5rem 0 0.5rem 1rem;
    position: relative;
    font-weight: 400;
  }
  th:nth-child(1),
  th:nth-child(2),
  th:nth-child(3),
  th:nth-child(4),
  th:nth-child(5),
  th:nth-child(6),
  td:nth-child(7) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
  }
  //th:nth-child(1)::after, th:nth-child(2)::after, th:nth-child(3)::after, th:nth-child(4)::after, th:nth-child(5)::after, th:nth-child(6)::after {
  //  content: "";
  //  position: absolute;
  //  right: 0;
  //  top: 50%;
  //  transform: translateY(-50%);
  //  height: 60%;
  //  border-right: 0.1rem solid #6F6F6F;
  //}
  td:nth-child(1),
  td:nth-child(2),
  td:nth-child(3),
  td:nth-child(4),
  td:nth-child(5),
  td:nth-child(6),
  td:nth-child(7) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    color: #6f6f6f;
  }
}

.btn-link {
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
  &:active {
    text-decoration: none;
  }
}
</style>
